module.exports = __webpack_public_path__ + "img/logo-dark.3547923.svg";